import { X, Plus } from "lucide-react"

import { Button } from "../../../../components/ui/button"
import { Input } from "../../../../components/ui/input"
import { DataTableViewOptions } from "../../../../components/ui/data-table-view-options"

interface UsersToolbarProps {
  table: any;
  onCreateUser?: () => void;
}

export function UsersToolbar({ 
  table, 
  onCreateUser
}: UsersToolbarProps) {
  const isFiltered = table.getState().columnFilters.length > 0

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filter users..."
          value={(table.getColumn("name")?.getFilterValue() as string) ?? ""}
          onChange={(event) =>
            table.getColumn("name")?.setFilterValue(event.target.value)
          }
          className="h-8 w-[150px] lg:w-[250px]"
        />
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <X className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="flex items-center space-x-2">
        {onCreateUser && (
          <Button onClick={onCreateUser} className="h-8">
            <Plus className="mr-2 h-4 w-4" />
            Create User
          </Button>
        )}
        <DataTableViewOptions table={table} />
      </div>
    </div>
  )
}
